import React from 'react';
export const Footer = () => {
  return <footer className="bg-gray-900 text-white py-8" data-id="element-99">
      <div className="max-w-4xl mx-auto px-4" data-id="element-100">
        <div className="flex justify-center mb-6" data-id="element-101">
          <div className="flex items-center" data-id="element-102">
            <div className="h-8 w-8 bg-white rounded-md flex items-center justify-center mr-2" data-id="element-103">
              <span className="text-gray-900 font-bold text-sm" data-id="element-104">K</span>
            </div>
            <h2 className="font-bold text-xl" data-id="element-105">KODIFY</h2>
          </div>
        </div>
        <div className="flex flex-wrap justify-center space-x-4 mb-6 text-sm" data-id="element-106">
          <a href="#privacy" className="hover:underline py-1" data-id="element-107">
            Privacy Policy
          </a>
          <a href="#terms" className="hover:underline py-1" data-id="element-108">
            Terms of Service
          </a>
          <a href="#contact" className="hover:underline py-1" data-id="element-109">
            Contact
          </a>
        </div>
        <div className="text-center text-gray-400 text-sm" data-id="element-110">
          © 2024 KODIFY. All rights reserved.
        </div>
      </div>
    </footer>;
};